import React from "react";
import { Link } from "gatsby";
import { formatFuzzyDate } from "./../../modules/time";

const ListList = ({ list, slug, title }) => (
  <div>
    <h3>{title}:</h3>
    <ul>
      {list.map((entry, index) => {
        const isRange = Boolean(entry.endDate);
        return (
          <li key={index + entry._id}>
            <Link to={`/${slug}/${entry._id}`}>{entry.title}</Link>{" "}
            {isRange
              ? !entry.date
                ? null
                : `${formatFuzzyDate(
                    entry.date,
                    entry.dateApproximateness
                  )}–${formatFuzzyDate(
                    entry.endDate,
                    entry.endDateApproximateness || entry.dateApproximateness
                  )}`
              : formatFuzzyDate(entry.date, entry.dateApproximateness)}
          </li>
        );
      })}
    </ul>
  </div>
);

export default ListList;
